// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BuildInfo, BuildInfoT, verifyBuildInfo } from "./build-info";
import { IdlBundle, IdlBundleT, verifyIdlBundle } from "./idl-bundle";
import { IdlOptions, IdlOptionsT, verifyIdlOptions } from "./idl-options";
import { MappingOverrides, MappingOverridesT, verifyMappingOverrides } from "./mapping-overrides";
import { ProductType } from "./product-type";

export class BuildRequest implements flatbuffers.IUnpackableObject<BuildRequestT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BuildRequest {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBuildRequest(bb: flatbuffers.ByteBuffer, obj?: BuildRequest): BuildRequest {
    return (obj || new BuildRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBuildRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: BuildRequest,
  ): BuildRequest {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BuildRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  productType(): ProductType | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  bundle(obj?: IdlBundle): IdlBundle | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IdlBundle()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  overrides(obj?: MappingOverrides): MappingOverrides | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new MappingOverrides()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  buildInfo(obj?: BuildInfo): BuildInfo | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new BuildInfo()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  options(obj?: IdlOptions): IdlOptions | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new IdlOptions()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startBuildRequest(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addProductType(builder: flatbuffers.Builder, productType: ProductType) {
    builder.addFieldInt8(0, productType, null);
  }

  static addBundle(builder: flatbuffers.Builder, bundleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bundleOffset, 0);
  }

  static addOverrides(builder: flatbuffers.Builder, overridesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, overridesOffset, 0);
  }

  static addBuildInfo(builder: flatbuffers.Builder, buildInfoOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, buildInfoOffset, 0);
  }

  static addOptions(builder: flatbuffers.Builder, optionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, optionsOffset, 0);
  }

  static endBuildRequest(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // bundle
    return offset;
  }

  unpack(): BuildRequestT {
    return new BuildRequestT(
      this.productType(),
      this.bundle() !== null ? this.bundle()!.unpack() : null,
      this.overrides() !== null ? this.overrides()!.unpack() : null,
      this.buildInfo() !== null ? this.buildInfo()!.unpack() : null,
      this.options() !== null ? this.options()!.unpack() : null,
    );
  }

  unpackTo(_o: BuildRequestT): void {
    _o.productType = this.productType();
    _o.bundle = this.bundle() !== null ? this.bundle()!.unpack() : null;
    _o.overrides = this.overrides() !== null ? this.overrides()!.unpack() : null;
    _o.buildInfo = this.buildInfo() !== null ? this.buildInfo()!.unpack() : null;
    _o.options = this.options() !== null ? this.options()!.unpack() : null;
  }

  unpackFields(...fields: string[]): BuildRequestT {
    const t = new BuildRequestT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("product_type")) {
      t.productType = this.productType();
    }
    if (fieldSet.has("bundle")) {
      t.bundle = this.bundle() !== null ? this.bundle()!.unpack() : null;
    }
    if (fieldSet.has("overrides")) {
      t.overrides = this.overrides() !== null ? this.overrides()!.unpack() : null;
    }
    if (fieldSet.has("build_info")) {
      t.buildInfo = this.buildInfo() !== null ? this.buildInfo()!.unpack() : null;
    }
    if (fieldSet.has("options")) {
      t.options = this.options() !== null ? this.options()!.unpack() : null;
    }
    return t;
  }
}

export class BuildRequestT implements flatbuffers.IGeneratedObject {
  constructor(
    public productType: ProductType | null = null,
    public bundle: IdlBundleT | null = null,
    public overrides: MappingOverridesT | null = null,
    public buildInfo: BuildInfoT | null = null,
    public options: IdlOptionsT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bundle === null || this.bundle === undefined) {
      throw new Error('Required field "bundle" is not set');
    }
    const bundle = this.bundle !== null ? this.bundle!.pack(builder) : 0;
    const overrides = this.overrides !== null ? this.overrides!.pack(builder) : 0;
    const buildInfo = this.buildInfo !== null ? this.buildInfo!.pack(builder) : 0;
    const options = this.options !== null ? this.options!.pack(builder) : 0;

    BuildRequest.startBuildRequest(builder);
    if (this.productType !== null) BuildRequest.addProductType(builder, this.productType);
    BuildRequest.addBundle(builder, bundle);
    BuildRequest.addOverrides(builder, overrides);
    BuildRequest.addBuildInfo(builder, buildInfo);
    BuildRequest.addOptions(builder, options);

    return BuildRequest.endBuildRequest(builder);
  }

  clone(): BuildRequestT {
    const obj = new BuildRequestT();
    obj.productType = this.productType;
    obj.bundle = this.bundle !== null ? this.bundle!.clone() : null;
    obj.overrides = this.overrides !== null ? this.overrides!.clone() : null;
    obj.buildInfo = this.buildInfo !== null ? this.buildInfo!.clone() : null;
    obj.options = this.options !== null ? this.options!.clone() : null;
    return obj;
  }

  equals(other: BuildRequestT): boolean {
    if (this.productType !== other.productType) return false;
    if (this.bundle !== null && other.bundle !== null) {
      if (!this.bundle!.equals(other.bundle!)) return false;
    } else if (this.bundle !== other.bundle) return false;
    if (this.overrides !== null && other.overrides !== null) {
      if (!this.overrides!.equals(other.overrides!)) return false;
    } else if (this.overrides !== other.overrides) return false;
    if (this.buildInfo !== null && other.buildInfo !== null) {
      if (!this.buildInfo!.equals(other.buildInfo!)) return false;
    } else if (this.buildInfo !== other.buildInfo) return false;
    if (this.options !== null && other.options !== null) {
      if (!this.options!.equals(other.options!)) return false;
    } else if (this.options !== other.options) return false;
    return true;
  }
}

export function verifyBuildRequest(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlBundle(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bundle");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMappingOverrides(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBuildInfo(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlOptions(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
